import React, { useEffect, useState } from 'react';
import classes from "./ProfilePage.module.css";
import Cookies from "js-cookie";
import { checkSubscriptionApi, deactivateApi, subscriptionLogsApi } from '../Http/http';
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Loader from '../Components/Loader';

const ProfilePage = () => {

    const [loading, setLoading] = useState(true);
    const [subscriptionLogs, setSubscriptionLogs] = useState(null);
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    const [renewalLogs, setRenewalLogs] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const onBack = () => {
        navigate("/");
    }

    const checkSubscription = async () => {
        try {
            setLoading(true);
            checkSubscriptionApi({ msisdn: Cookies.get("msisdn") }).then(() => {
                setLoading(false);
            }).catch(err => {
                Cookies.remove('msisdn');
                window.location.href = "https://subscribe-d2g.rashigames.com/"
            });

            subscriptionLogsApi({ msisdn: Cookies.get("msisdn") }).then((response) => {
                console.log(response, 'd');

                setSubscriptionLogs(response?.data?.subscriptionData);
                setRenewalLogs(response?.data?.chargingData);
            }).catch(err => {
                console.log("error----", err);
                alert("Try Reload! Something Went Wrong!");
            })

            // setLoading(false);
        } catch (error) {
            setLoading(false);
            alert("Something Went Wrong!");
        }
    }

    useEffect(() => {
        if (Cookies.get("msisdn")) {
            checkSubscription();
        }
        else {
            window.location.href = "https://subscribe-d2g.rashigames.com/"
        }
    }, []);

    const handleDeactivate = async () => {
        try {
            setDeactivateLoading(true);
            const response = await deactivateApi({ msisdn: Cookies.get("msisdn") });
            setDeactivateLoading(false);
            setShowModal(false);
            navigate("/deactivation");
        } catch (error) {
            setDeactivateLoading(false);
            alert("Something Went Wrong, Try Again!")
        }
    }

    return (
        <div className={classes.pageWrapper}>

            <div className={classes.header}>
                <div className={classes.header_1}>
                    <button className={classes.backButton} onClick={onBack}>
                        <FaArrowLeft size={20} />
                    </button>
                    {/* <h1 className={classes.heading}>My Profile</h1> */}
                </div>

                <div className={classes.actionButtons}>
                    <button type="button" className={classes.deactivate_button}
                        onClick={() => setShowModal(true)}
                    >
                        Deactivate
                    </button>
                    <button type="button" className={classes.logout_button}
                        onClick={() => {
                            Cookies.remove('msisdn');
                            window.location.href = "https://subscribe-d2g.rashigames.com/login";
                        }}
                    >
                        Logout
                    </button>
                </div>

                {/* <button type="button" className={classes.deactivate_button}
                    onClick={() => setShowModal(true)}
                >
                    Deactivate
                </button> */}
            </div>

            {loading ? <Loader /> : (
                <>
                    <div className={classes.section}>
                        <h2 className={classes.sectionHeading}>Subscription Details</h2>

                        <div className={classes.cardList}>
                            {subscriptionLogs?.map((log, index) => (
                                <div key={index} className={classes.card}>
                                    <p><strong>Pack:</strong> {log?.pack_type}</p>
                                    <p><strong>Amount:</strong> {log?.amount}</p>
                                    <p><strong>Subscribed On:</strong> {new Date(log?.subDateTime).toLocaleDateString()}</p>
                                    <p><strong>Next Billing Date:</strong> {new Date(log?.nextBilledDateTime).toLocaleDateString()}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* <div className={classes.section}>
                        <h2 className={classes.sectionHeading}>Charging Details</h2>
                        <div className={classes.cardList}>
                            {renewalLogs?.map((log, index) => (
                                <React.Fragment key={index}>
                                    <div className={classes.card}>
                                        <p><strong>Pack Type:</strong> {log?.pack_type}</p>
                                        <p><strong>Amount:</strong> {log?.chargeAmount}</p>
                                        <p><strong>Renewal On:</strong> {new Date(log?.billingDateTime).toLocaleDateString()}</p>
                                        <p><strong>Transaction ID:</strong> {log?.transactionId}</p>
                                    </div>
                                    {index < renewalLogs.length - 1 && <div className={classes.divider} />}
                                </React.Fragment>
                            ))}
                        </div>
                    </div> */}
                </>
            )}




            {showModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modal}>
                        <h3>Confirm Deactivation</h3>
                        <p>Are you sure you want to deactivate your subscription?</p>
                        <div className={classes.modalActions}>
                            <button onClick={() => setShowModal(false)}
                                disabled={deactivateLoading}
                            >Cancel</button>
                            <button onClick={handleDeactivate}
                                disabled={deactivateLoading}
                                className={classes.confirmButton}>
                                {deactivateLoading ? "Please Wait..." : "Yes, Deactivate"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ProfilePage